<template>
  <div class="d-inline-block">
    <div
      class="nav-item borrow-invest-item d-none d-lg-block"
      @mouseenter="onMouseEnter($event, 'borrow', true)"
      @mouseleave="onMouseEnter($event, 'borrow', false)"
    >
      <button
        :class="`${borrowInvestModel === 'borrow' ? 'has-arrow has-arrow-borrow' : ''}`"
        class="btn btn-cash-hero"
        data-toggler="true"
        href="javascript:void(0)"
        @click="onClickBorrowInvest('borrow')"
      >
        <i class="fas fa-hand-holding-usd" />
        {{ $t('label.loanNow') }}
      </button>

      <div
        :class="borrowInvestModel === 'borrow' ? 'active' : ''"
        class="sub-nav-content-borrow sub-navbar-content"
      >
        <div class="sub-nav-panel">
          <nav role="navigation">
            <div>
              <ul class="borrow-dropdown">
                <!--              Payday Loan-->
                <li class="sub-nav-item2 sub-nav-item">
                  <router-link
                    class="sub-nav-penal-item has-border-r"
                    to=""
                    @click.native="applyNewLoan('Payday')"
                  >
                    <span class="sub-nav-panel-title bold">{{ $t('label.payDayLoan') }}</span>
                    <i class="fa fa-chevron-right nav-chevron-right" />
                    <span class="sub-nav-panel-desc">{{ $t('borrow.string.shortTerm') }}</span>
                  </router-link>
                </li>
                <!--              Personal Loan-->
                <li class="sub-nav-item2 sub-nav-item">
                  <router-link
                    class="sub-nav-penal-item"
                    to=""
                    @click.native="applyNewLoan('Personal')"
                  >
                    <span class="sub-nav-panel-title bold">{{ $t('label.personalLoan') }}</span>
                    <i class="fa fa-chevron-right nav-chevron-right" />
                    <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
                  </router-link>
                </li>
                <!--              Installment Loan-->
                <li class="sub-nav-item2 sub-nav-item">
                  <router-link
                    class="sub-nav-penal-item has-border-r"
                    to=""
                    @click.native="applyNewLoan('Purchasing')"
                  >
                    <span class="sub-nav-panel-title bold">{{ $t('label.purchasing') }}</span>
                    <i class="fa fa-chevron-right nav-chevron-right" />
                    <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
                  </router-link>
                </li>
                <!--              Pawn Loan-->
                <li class="sub-nav-item2 sub-nav-item">
                  <router-link
                    class="sub-nav-penal-item"
                    to=""
                    @click.native="applyNewLoan('Pawn')"
                  >
                    <span class="sub-nav-panel-title bold">{{ $t('label.pawn') }}</span>
                    <i class="fa fa-chevron-right nav-chevron-right" />
                    <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm_1_12') }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <button
      id="navbarDropdownBorrow"
      aria-expanded="false"
      aria-haspopup="true"
      class="btn btn-cash-hero dropdown-toggle d-block d-sm-none mr-1"
      data-toggle="dropdown"
      href="javascript:void(0)"
      role="button"
    >
      <i class="fas fa-hand-holding-usd" />
      {{ $t('label.loanNow').toUpperCase() }}
    </button>
    <div
      aria-labelledby="navbarDropdown"
      class="dropdown-menu"
    >
      <router-link
        class="dropdown-item must-wrap pb-2 pt-1 border-bottom"
        to=""
        @click.native="applyNewLoan('Payday')"
      >
        <span class="sub-nav-panel-title bold">{{ $t('label.payDayLoan') }}</span>
        <i class="fa fa-chevron-right nav-chevron-right" />
        <span class="sub-nav-panel-desc">{{ $t('borrow.string.shortTerm') }}</span>
      </router-link>
      <router-link
        class="dropdown-item must-wrap pb-1 pt-2 border-bottom"
        to=""
        @click.native="applyNewLoan('Personal')"
      >
        <span class="sub-nav-panel-title bold">{{ $t('label.personal_loan') }}</span>
        <i class="fa fa-chevron-right nav-chevron-right" />
        <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
      </router-link>
      <!--              Installment Loan-->
      <router-link
        class="dropdown-item must-wrap pb-1 pt-2 border-bottom"
        to=""
        @click.native="applyNewLoan('Purchasing')"
      >
        <span class="sub-nav-panel-title bold">{{ $t('label.purchasing') }}</span>
        <i class="fa fa-chevron-right nav-chevron-right" />
        <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
      </router-link>
      <!--              Pawn Loan-->
      <router-link
        class="dropdown-item must-wrap pb-1 pt-2"
        to=""
        @click.native="applyNewLoan('Pawn')"
      >
        <span class="sub-nav-panel-title bold">{{ $t('label.pawn') }}</span>
        <i class="fa fa-chevron-right nav-chevron-right" />
        <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm_1_12') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBorrow',
  props: {
    bright: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    borrowInvestModel: function () {
      if (this.borrowInvestModel !== 'none') {
        this.allowClickToClose = false
        const self = this
        setTimeout(function () {
          self.allowClickToClose = true
        }, 500)
      }
    }
  },
  data () {
    return {
      locale: this.$i18n.locale,
      borrowInvestModel: 'none', // 'borrow', 'invest', 'none'
      borrowInvestModelHandler: null,
      brand: process.env.VUE_APP_NAME,
      allowClickToClose: true
    }
  },
  computed: {
    navItemClass () {
      if (this.bright) {
        return 'nav-item black'
      }
      return 'nav-item'
    },
    navLinkPadding () {
      if (this.$i18n.locale === 'km') {
        return 'padding: 0 0.5rem;'
      } else {
        return 'padding: 0 1rem;'
      }
    }

  },
  methods: {
    applyNewLoan (loan_type) {
      sessionStorage.setItem('typeOfLoan', loan_type)
      this.$store.dispatch('setLoanType', loan_type)
      this.$store.dispatch('clearAmountAndDuration')
      this.closeNavBar()
      this.onNavBarDropDown()
      this.$router.push({ name: 'new-loan' })
    },
    onMouseEnter (event, value, enter) {
      clearTimeout(this.borrowInvestModelHandler)
      if (enter) {
        this.borrowInvestModelHandler = setTimeout(() => {
          this.borrowInvestModel = value
        }, 300)
      }
    },
    onClickBorrowInvest (item) {
      if (this.borrowInvestModel === item) {
        if (this.allowClickToClose) {
          this.borrowInvestModel = 'none'
        }
      } else {
        this.borrowInvestModel = item
      }
    },
    onNavBarDropDown () {
      this.borrowInvestModel = 'none'
      $(document).scrollTop(0)
    },
    closeNavBar () {
      if ($) {
        $('.navbar-collapse').collapse('hide')
      }
    },
    detectMouseClick: function (e) {
      if ($(e.target).data('toggler')) {
        return
      }
      if (this.borrowInvestModel !== 'none' && e.target.closest('.sub-navbar-content') === null) {
        this.borrowInvestModel = 'none'
      }
    }
  },
  mounted () {
    $(document).on('click', this.detectMouseClick)
  },
  destroyed () {
    $(document).off('click', this.detectMouseClick)
  }
}
</script>

<style scoped>
a {
  color: var(--primary) !important;
  display: block;
}

a:hover {
  text-decoration: none !important;
}

.borrow-dropdown {
  margin-bottom: 0;
  padding: 0;
  text-align: left;
}

.borrow-dropdown > li {
  display: inline-block;
}

.nav-item {
  display: inline-block !important;
  padding-bottom: 5px;
  /*width: fit-content !important;*/
  margin-right: 5px;
}

.black > a {
  color: white !important;
}

.dropdown-item.active {
  color: white !important;
}

.active {
  font-weight: bold;
}

.active > a {
  color: white !important;
}

.dropdown-item.active, .dropdown-item:active {
  background-color: var(--primary);
  color: white;
}

.dropdown-item.active:hover, .dropdown-item:active {
  color: white !important;
}

#mainNav.navbar-scrolled .navbar-nav .nav-item .nav-link:hover,
#mainNav .navbar-nav .nav-item .nav-link:hover {
  color: var(--very-light-blue) !important;
}

.sub-nav-content-borrow {
  width: 540px;
  left: calc(50% - 272px);
}

.sub-navbar-content {
  position: absolute;
  background: white;
  padding: 15px;
  display: none;
  top: 48px;
  margin: 0;
  border: 1px solid #e2e5e5;
  border-radius: 20px;
  box-shadow: 1px 8px 35px #00000044;
  height: auto;
  z-index: 104;
}

.sub-nav-panel {
  position: relative;
  font-size: 1rem;
  color: white;
}

.sub-nav-item2 {
  width: 50%;
}

.sub-nav-item {
  padding: 10px 0 10px 20px;
}

.sub-nav-item::after:last-child {
  border: none;
}

.sub-nav-penal-item {
  padding-right: 10px;
}

.has-border-r {
  border-right: 1px solid #cac7c7;
}

.sub-nav-panel-title {
  font-size: 1.0625rem;
}

.nav-chevron-right {
  margin: 0 5px;
  font-size: 13px;
}

.sub-nav-item:hover {
  cursor: pointer;
}

.sub-nav-item:hover .sub-nav-panel-title,
.sub-nav-item:hover .nav-chevron-right {
  color: var(--secondary) !important;
}

.sub-nav-panel-desc {
  display: block;
  padding-top: 10px;
  font-weight: lighter;
}

.bold {
  font-weight: 400;
}

.has-arrow-borrow::before {
  left: calc(50% - 20px);
}

.has-arrow-invest::before {
  left: calc(50% - 10px);
}

.has-arrow::before {
  content: "";
  position: absolute;
  bottom: -20px;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  border-bottom: 15px solid white;
  z-index: 105;
}

@media screen and (max-width: 991px) {
  #mainNav .navbar-nav .nav-item .nav-link {
    padding: 0.4rem 0 !important;
  }
}

.borrow-invest-item {
  position: relative;
}

.borrow-invest-item > div.active {
  display: block;
  border-bottom: 0;
}

.borrow-item::after {
  position: absolute;
  top: -10px;
  left: -10px;
  background-color: transparent;
  height: 30px;
  width: 30px;
  border-top: 3px solid var(--secondary);
  border-left: 3px solid var(--secondary);
  transition: 300ms;
}

.borrow-item:hover::after {
  border-top-left-radius: 20px;
}

@media screen and (min-width: 992px) {

  .show-dropdown {
    display: none;
  }

  .active {
    font-weight: normal;
    border-bottom: 2px solid var(--very-light-blue);
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown) > a {
    height: 100%;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown):not(.active) {
    position: relative;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown):not(.active):after {
    content: '';
    background-color: var(--very-light-blue) !important;
    position: absolute;
    transition: 300ms;
    height: 2px;
    bottom: 0px;
    width: 0;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown):not(.active):hover:after {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .sub-nav-content-borrow {
    width: 500px;
    left: calc(70% - 272px);
  }
}

@media (max-width: 576px) {
  .d-none {
    display: none !important;
  }

  .d-block {
    display: inline-block !important;
  }
}
</style>
